import { useNavigate } from "react-router";

const DestinationCard = ({ destination }: { destination: any }) => {
  const navigate = useNavigate();

  return (
    <div className="p-2">
      <div
        className="Destinations-card"
        onClick={() => navigate(`/tour/${destination?.SectorURL}/`)}
      >
        <div className="Destinations-card-pic">
          <img src={destination?.SectorImage} alt={destination?.SectorName} />
        </div>
        <div className="Destinations-card-body">
          <h4>{destination?.SectorName}</h4>
        </div>
      </div>
    </div>
  );
};

export default DestinationCard;
